import * as z from "zod";
import { gql } from "graphql-request";

import { SysSchema, SysFragment } from "./sys";
import { TargetingSchema, TargetingFragment } from "./targeting";
import { RelatedMediaSchema, RelatedMediaFragment } from "./relatedMedia";
import {
  LocalizedHeroSchema,
  LocalizedHeroFragment,
} from "./newsEntryTypes/localizedHero";
import {
  CarouselEventProgressTrackerEntrySchema,
  CarouselEventProgressTrackerEntryFragment,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";
import {
  EventCalendarEntrySchema,
  EventCalendarEntryFragment,
} from "./newsEntryTypes/eventCalendarEntry";

export const HeroSchema = z.object({
  __typename: z.literal("Hero"),
  sys: SysSchema,
  targeting: TargetingSchema.nullable(),
  relatedMedia: RelatedMediaSchema.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      LocalizedHeroSchema,
      CarouselEventProgressTrackerEntrySchema,
      EventCalendarEntrySchema,
    ])
    .nullish(),
});

export const Hero = HeroSchema;
export type Hero = z.infer<typeof HeroSchema>;

export const HeroFragment = gql`
  fragment HeroFragment on Hero {
    __typename
    sys {
      ...SysFragment
    }
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    localized {
      ... on LocalizedHero {
        ...LocalizedHeroFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
      ... on EventCalendarEntry {
        ...EventCalendarEntryFragment
      }
    }
  }
  ${SysFragment}
  ${LocalizedHeroFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
  ${CarouselEventProgressTrackerEntryFragment}
  ${EventCalendarEntryFragment}
`;
